import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'booleanToYN',
  standalone: true,
})
export class BooleanToYNPipe implements PipeTransform {
  transform(value: boolean | null | undefined): string {
    return value ? 'Y' : 'N';
  }
}
